export class Invoice {
  public static fromBE(data: any) {
    const { id, invoiceNumber, amount } = data;
    return new Invoice(id, invoiceNumber, amount);
  }

  constructor(
    readonly id: number,
    readonly invoiceNumber: number,
    readonly amount: number,
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/model/Invoice.ts